import React, { useState } from 'react';
import { connect } from 'react-redux';
import { ModalBody } from '../../../components/modal/Modal';
import { IModuleParam } from '../../../redux/progress/module/moduleInterface';
import { IState } from '../../../redux/store';
import { IDataDirInfo } from './DataDirInfo';
import FileDirPicker from './FileDirPicker';
import FilePickerTable from './FilePickerTable';
import './FilePicker.css';

function FilePicker(props: {
    userName: string,
    activeProjectName: string,
    close: () => void;
    param: IModuleParam;
    onChange?: (value: string) => void;
    diffraction: string
}) {
    const [projectInfo, setProjectInfo] = useState<IDataDirInfo>();
    
    return <ModalBody>
        <div className='file-picker'>
            <FileDirPicker choosed={projectInfo} modele={props.diffraction} onChoose={(info) => {
                setProjectInfo(info)
            }} />
            <>{projectInfo ? <FilePickerTable onChange={props.onChange} dataInfo={projectInfo} close={() => props.close()} param={props.param} /> : null}</>

        </div>
    </ModalBody>
}

const mapStateToProps = (state: IState) => {
    return {
        userName: state.user.userName,
        activeProjectName: state.project.activeName
    };
};


export default connect(
    mapStateToProps
)(FilePicker);